<template>
  <v-container>
    <v-row class="my-16">
      <v-col cols="12">
        <h1>Logos</h1>
      </v-col>
    </v-row>
    <v-row class="my-16">
      <v-col cols="12">
        <h3>Logomark: White</h3>
        <LogoComponent
          src="/img/logo/andromeda_logomark-white_bg-transparent.png"
          class="pr-12 mt-12"
        ></LogoComponent>
        <LogoComponent
          src="/img/logo/andromeda_logomark-black_bg-transparent.svg"
          class="pr-12 mt-12"
        ></LogoComponent>
      </v-col>
    </v-row>
    <v-row class="my-16">
      <v-col cols="12">
        <h3>Logomark: Gray, Black</h3>
        <LogoComponent
          src="/img/logo/andromeda_logomark-gray_bg-transparent.png"
          class="pr-12 mt-12"
        ></LogoComponent>
        <LogoComponent
          src="/img/logo/andromeda_logomark-black_bg-white.png"
          class="pr-12 mt-12"
        ></LogoComponent>
        <LogoComponent
          src="/img/logo/andromeda_logomark-black_bg-transparent.png"
          class="pr-12 mt-12"
        ></LogoComponent>
      </v-col>
    </v-row>
    <v-row class="my-16">
      <v-col cols="12">
        <h3>Logotype, Logo: Gray</h3>
        <LogoComponent
          src="/img/logo/andromeda_logotype-gray_bg-transparent.png"
          class="pr-12 mt-12"
        ></LogoComponent>
        <LogoComponent
          src="/img/logo/andromeda_logo-gray_bg-transparent.png"
          class="pr-12 mt-12"
        ></LogoComponent>
      </v-col>
    </v-row>
  </v-container>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import LogoComponent from './LogoComponent.vue';

export default defineComponent({
  name: "LogosComponent",
  components: {
    LogoComponent,
  },
  props: {
    src: {
      type: String,
      required: false,
      default: undefined,
    },
    name: {
      type: String,
      required: false,
      default: undefined,
    },
  },
});
</script>
